var READING = "reading";
var WRITING = "writing";
var OG_READING = "og-reading";

var Skillsets = {
	TYPES: {
		"ri1-key-details": {
			name: "RI1 - Key Ideas & Details - Details",
			type: READING,
			env: "underwater",
			non_fiction_only: true
		},
		"ri2-key-main": {
			name: "RI2 - Key Ideas & Details - Main Ideas",
			type: READING,
			env: "lake",
			non_fiction_only: true
		},
		"ri5-craft-structure": {
			name: "RI5 - Craft & Structure - Structure",
			type: READING,
			env: "sky",
			non_fiction_only: true
		},
		"ri6-craft-pov": {
			name: "RI6 - Craft & Structure - Points of View",
			type: READING,
			env: "tundra",
			non_fiction_only: true
		},
		"ri7-integration-media": {
			name: "RI7 - Integration of Knowledge & Ideas - Media Portrayals",
			type: READING,
			env: "farm",
			non_fiction_only: true
		},
		"ri8-integration-linear": {
			name: "RI8 - Integration of Knowledge & Ideas - Linear Reasoning",
			type: READING,
			env: "beach",
			non_fiction_only: true
		},

		"rl1-key-details": {
			name: "RL1 - Key Ideas & Details - Details",
			type: READING,
			env: "space",
			fiction_only: true
		},
		"rl2-key-main": {
			name: "RL2 - Key Ideas & Details - Main Ideas",
			type: READING,
			env: "city",
			fiction_only: true
		},
		"rl3-key-connections": {
			name: "RL3 - Key Ideas & Details - Connections",
			type: READING,
			env: "savannah",
			fiction_only: true
		},
		"rl5-craft-structure": {
			name: "RL5 - Craft & Structure - Structure",
			type: READING,
			env: "jungle",
			fiction_only: true
		},
		"rl6-craft-pov": {
			name: "RL6 - Craft & Structure - Points of View",
			type: READING,
			env: "mushrooms",
			fiction_only: true
		},
		"rl7-integration-media": {
			name: "RL7 - Integration of Knowledge & Ideas - Media Portrayals",
			type: READING,
			env: "desert",
			fiction_only: true
		},

		"pov": {
			name: "Purpose & Point of View",
			type: OG_READING,
			env: "underwater",
		},
		"developments": {
			name: "Developments & Interactions",
			type: OG_READING,
			env: "sky",
		},
		"inferences": {
			name: "Inferences",
			type: OG_READING,
			env: "tundra",
		},
		"ideas": {
			name: "Key Ideas",
			type: OG_READING,
			env: "lake",
		},
		"vocabulary": {
			name: "Vocabulary",
			type: OG_READING,
			env: "farm",
		},
		"structure": {
			name: "Text Structure",
			type: OG_READING,
			env: "beach",
		},
		"media": {
			name: "Medias & Formats",
			type: OG_READING,
			env: "space",
		},
		"arguments": {
			name: "Arguments & Evidence",
			type: OG_READING,
			env: "city",
			stems: ["nfarg"]
		},
		"connections": {
			name: "Text to Text Connections",
			type: OG_READING,
			env: "savannah",
		},


		"caps": {
			name: "Capitalization",
			type: WRITING,
			env: "forest"
		},
		"evidence": {
			name: "Citing Evidence",
			type: WRITING,
			env: "forest"
		},
		"org": {
			name: "Organization",
			type: WRITING,
			env: "forest"
		},
		"spelling": {
			name: "Spelling",
			type: WRITING,
			env: "forest"
		},
		"word": {
			name: "Word Use",
			type: WRITING,
			env: "forest"
		},
		"conventions": {
			name: "Writing Conventions",
			type: WRITING,
			env: "forest"
		},

	},

	// It's not really a skill set but it's sometimes treated like one:
	REVIEW: {
		name: "Book Review",
		standard: "None",
		description: "Write a book review about what you've written to share your knowledge with people who might not have read the text.",
		env: "review",
		paid: false
	},

	getData(skillsetKey) {
		if (skillsetKey == "review") {
			return Skillsets.REVIEW;
		} else {
			return Skillsets.TYPES[skillsetKey];
		}
	},

	getName: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return skillset.name; }
	},

	getShortName: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return _.last(skillset.name.split(" - ")); }
	},

	getStandard: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return skillset.standard; }
	},

	getDescription: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return skillset.description; }
	},

	getIcon: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) {
			return dynamicRequire("skillset-icons/icon-" + skillset.env + ".png");
		}		
	},

	getBanner: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if ($wr.isDevelopment()) {
			var imgBase = "http://localhost:3003";
		} else if ($wr.isProduction()) {
			var imgBase = "https://app.whooosreading.org/albus_assets";
		} else if ($wr.isStaging()){
			var imgBase = "https://app.savvashortondev.com/albus_assets";
		}

		if (skillset) {
			return imgBase + "/skillset_banners/banner-" + skillset.env + ".png";
		}
	},

	getStems: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);		
		if (skillset) {return skillset.stems}
	},

	isPaid: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return skillset.paid; }
	},

	hasFiction: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return !skillset.non_fiction_only; }
	},

	hasNonFiction: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return !skillset.fiction_only; }
	},

	isReading: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return skillset.type == READING; }
	},

	isOgReading: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return skillset.type == OG_READING; }
	},

	isWriting: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return skillset.type == WRITING; }
	}

}

Skillsets.SKILLSET_KEYS = _.keys(Skillsets.TYPES);
Skillsets.READING_SKILLSET_KEYS = _.select(Skillsets.SKILLSET_KEYS, Skillsets.isReading);

module.exports = Skillsets;



// WEBPACK FOOTER //
// ./modules/lib/academic/Skillsets.js